document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-bb-rd-menu][open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-bb-rd-menu][open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-bb-rd-add]')) return;
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[role="alert"]');
  const input = form.querySelector('[name="id"]');
  if (!button || !input?.value) return;
  const source = form.dataset.source || 'bb-cart-upsell';
  const label = button.innerHTML;
  form.dataset.pending = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = 'Adding…';
  if (error) error.hidden = true;
  const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId).filter(Boolean))];
  document.dispatchEvent(new CustomEvent('cart:add-started', {bubbles: true, detail: {sourceId: source, data: {source, variantId: input.value, itemCount: 1}}}));
  try {
    const response = await fetch(form.action + '.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({items: [{id: Number(input.value), quantity: 1}], sections: sections.join(','), sections_url: location.pathname})
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Please try again.');
    let cart = null;
    try {
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {headers: {Accept: 'application/json'}});
      if (cartResponse.ok) cart = await cartResponse.json();
    } catch {}
    document.dispatchEvent(new CustomEvent('cart:update', {bubbles: true, detail: {resource: cart || data, sourceId: source, data: {source, variantId: input.value, itemCount: cart?.item_count, sections: data.sections}}}));
  } catch (failure) {
    if (error) {
      error.textContent = failure instanceof Error ? failure.message : 'Please try again.';
      error.hidden = false;
    }
    document.dispatchEvent(new CustomEvent('cart:error', {bubbles: true, detail: {sourceId: source, data: {message: 'Could not add this item', description: failure instanceof Error ? failure.message : ''}}}));
  } finally {
    form.dataset.pending = 'false';
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.innerHTML = label;
  }
});

